<!--
 * @FileDescription: 地方研究院和科技园情况展板
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: dcq
 * @LastEditTime: 2023-07-26 13:06:54
 -->
<template>
    <div class="search-tab">
        <!-- <div class="up-template"> -->
        <SearchKeyValTempVue 
            order="0" title="地方研究院和科技园情况" keyValId="3" 
            :searchInformation="searchInformation"
            urlTitle="科技载体网站" :searchSciIndex="currentSearchSciIndex"
        />
        <SearchPicTemp order="4" :searchSciIndex="currentSearchSciIndex" keyId="3" />
        <SearchDesTempVue order="5" :searchSciIndex="currentSearchSciIndex" keyValId="3" />

        <!-- </div> -->
        <SearchMapTemplate order="3" @click-science="ChangeSearchSci"></SearchMapTemplate>
        
    </div>
</template>

<script>
export default {
    name: 'SearchTab',

   

}

</script>

<script setup>
import { ref ,onMounted } from 'vue';
// import requestApi from '@/api/requestApi';
// import KeyValTemplate from './tabTemplates/KeyValTemplate.vue';
// import MapTemplate from './tabTemplates/MapTemplate.vue';
// import { urlSearchData } from './tabTemplates/schoolData';
import SearchMapTemplate from './tabTemplates/SearchMapTemplate.vue';
// import PicCarousel from './tabTemplates/PicCarousel.vue';
// import DescribeTemplate from './tabTemplates/DescribeTemplate.vue'
import SearchPicTemp from './tabTemplates/SearchPicTemp.vue';
// import { BorderBox10 as DvBorderBox10 } from '@kjgl77/datav-vue3'
import SearchKeyValTempVue from './tabTemplates/SearchKeyValTemp.vue';
import SearchDesTempVue from './tabTemplates/SearchDesTemp.vue';
// import activeJson from "/public/activeChartData.json"

import axios from 'axios';


let searchNum=ref()
let activeJson=ref({})
let searchInformation = ref([
    { name: '园区', val: searchNum.value + '所' },
    { name: '占地面积', val: '39535平方米' },
    { name: '覆盖区县', val: '6个' },
])

onMounted(() => {
//   console.log(`the component is now mounted.`)
  axios.get('/activeChartData.json')
      .then(response => {
        activeJson.value= response.data;
        searchNum.value=activeJson.value.searchSciPt.features.length
        searchInformation.value[0]={ name: '园区', val: searchNum.value + '所' }
      })
      .catch(error => {
        console.log(error);
      });
})


// var searchNum =  activeJson.searchSciPt.features.length


// const urlData = urlSearchData


const currentSearchSciIndex = ref(0);

const ChangeSearchSci = (searchSciIndex) => {
    currentSearchSciIndex.value = searchSciIndex;
    console.log('change searchSci', searchSciIndex);
}

</script>


<style lang="scss" scoped>
div.search-tab {
    position: relative;
    width: 100vw;
    height: 84vh;
    // display: flex;
    // flex-flow: column wrap;
    // justify-content: space-between;
    // background-color: red;

    // div.up-template {
    //     position: relative;
    //     background: transparent;
    //     // top: 16vh;
    //     width: 100vw;
    //     height: 84vh;
    // }


}
</style>